import React, { useState } from 'react'
import classes from './MyStudentsProlongationsTableRecord.module.css'
import { Td, Tr, Link, Text, Flex, Button, Input, useToast } from '@chakra-ui/react'
import { CheckIcon, NotAllowedIcon } from '@chakra-ui/icons'
import MailingCheckbox from './MailingCheckbox'
import SelectCommunicationType from '../SelectCommunicationType/SelectCommunicationType'
import MailingSelectTitle from './MailingSelectTitle'
import { useProlongationDetailModalStore } from '../../store/modalsStore'
import RoleTag from '../UI/RoleTag'
import ProlongationService from '../../API/ProlongationService'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useProlongationsStore } from '../../store/prolongationsStore'

function MyStudentsProlongationsTableRecord({prolongation}) {
    const prolongationDetailModalDislosure = useProlongationDetailModalStore(state => state.disclosure)
    const setModalProlongation = useProlongationDetailModalStore(state => state.setProlongation)
    const [comment, setComment] = useState(prolongation?.comment || '')
    const [commentLoading, setCommentLoading] = useState(false)
    const toast = useToast()
    const updateProlongation = useProlongationsStore(state => state.updateProlongation)

    const onDetailBtn = () => {
        setModalProlongation(prolongation)
        prolongationDetailModalDislosure.onOpen()
    }

    const saveComment = async () => {
        setCommentLoading(true)
        const response = await ProlongationService.updateComment(prolongation.prolongation_id, comment)
        if (response?.status === 200) {
            updateProlongation({...prolongation, comment: comment})
            toast(toastSuccess('Комментарий обновлен'))
        } else {
            toast(toastError('Не удалось обновить комментарий'))
        }
        setCommentLoading(false)
    }

    return (
        <Tr whiteSpace='nowrap'>
            <Td className={classes.fixedCol}>
                <Flex direction='column' gap='4px'>
                    <Link isExternal href={`https://vk.com/id${prolongation.vk_id}`}>
                        {prolongation.student_name}
                    </Link>
                    <Link isExternal href={prolongation.vk_link} color='gray'>
                        Диалог
                    </Link>
                </Flex>
            </Td>
            <Td>
                <Link
                    isExternal
                    href={`https://old.umschool.net/predbannik/core/user/${prolongation?.umschool_id}`}
                >
                    {prolongation?.umschool_id}
                </Link>
            </Td>
            <Td>
                <SelectCommunicationType student={prolongation} />
            </Td>
            <Td>
                {prolongation.products.map((pr) => (
                    <Text p='4px' key={`product${prolongation.prolongation_id}${pr.subject}`}>
                        {pr.subject}
                    </Text>
                ))}
            </Td>
            <Td>
                <Flex alignItems='center' direction='column' gap='8px'>
                    {prolongation.products.map((pr) => (
                        pr?.is_packs_prev
                        ?
                        <CheckIcon boxSize={5} color='green' key={`is_packs_prev${prolongation.prolongation_id}${pr.subject}`}/>
                        :
                        <NotAllowedIcon boxSize={5} color='red' key={`is_packs_prev${prolongation.prolongation_id}${pr.subject}`}/>
                    ))}
                </Flex>
            </Td>
            <Td>
                {prolongation.products.map((pr) => (
                    <Text p='4px' key={`stream_prev${prolongation.prolongation_id}${pr.subject}`}>
                        {pr.stream_prev}
                    </Text>
                ))}
            </Td>
            <Td>
                {prolongation.products.map((pr) => (
                    <Text p='4px' key={`grade_name${prolongation.prolongation_id}${pr.subject}`}>
                        {pr.grade_name}
                    </Text>
                ))}
            </Td>
            <Td>
                <MailingCheckbox prolongation={prolongation} key={`checkbox${prolongation.id}`}/>
            </Td>
            <Td>
                {prolongation?.date_contact_1}
            </Td>
            <Td>
                <MailingSelectTitle number={1} prolongation={prolongation} />
            </Td>
            <Td>
                {prolongation?.date_contact_2}
            </Td>
            <Td>
                {prolongation?.status_1 &&
                <MailingSelectTitle number={2} prolongation={prolongation} />}
            </Td>
            <Td>
                {prolongation?.date_contact_3}
            </Td>
            <Td>
                {prolongation?.status_2 &&
                <MailingSelectTitle number={3} prolongation={prolongation} />}
            </Td>
            <Td>
                {prolongation?.status_1 &&
                <MailingSelectTitle number={4} prolongation={prolongation} />}
            </Td>
            <Td>
                <Flex gap='6px'>
                    <Input
                        disabled={!prolongation?.checkbox}
                        size='sm'
                        minW='200px'
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                    />
                    <Button
                        size='sm'
                        disabled={!prolongation?.checkbox || !comment || commentLoading || prolongation.comment === comment}
                        onClick={saveComment}
                    >
                        <CheckIcon />
                    </Button>
                </Flex>
            </Td>
            <Td>
                <Flex alignItems='center' justifyContent='center'>
                    <RoleTag
                        role={{ title: prolongation.color }}
                        colorScheme={prolongation.color}
                    />
                </Flex>
            </Td>
            <Td>
                {prolongation?.is_new}
            </Td>
            <Td>
                <Flex alignItems='center' direction='column' gap='8px'>
                    {
                    prolongation?.max_sub === 1
                    ?
                    <CheckIcon boxSize={5} color='green' key={`max_sub${prolongation.prolongation_id}`}/>
                    :
                    <NotAllowedIcon boxSize={5} color='red' key={`max_sub${prolongation.prolongation_id}`}/>
                    }
                </Flex>
            </Td>
            <Td>
                {prolongation?.cohort}
            </Td>
            <Td>
                <Button size='sm' onClick={onDetailBtn}>
                    Подробнее
                </Button>
            </Td>
        </Tr>
    )
}

export default MyStudentsProlongationsTableRecord
